import React, { useEffect, useState } from 'react';
import './dashboard-challenges.container.sass';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentChallenges } from './dashboard-challenges.slice';
import { Challenge } from './components/challenge/challenge';
import { getTeamVendorId } from '../../login/session.slice';
import { getCurrentPlan } from '../payments/dashboard-plan.slice';
import { ReactComponent as IconPlus } from '../../../assets/icons/plus.svg';

export const DashboardChallengesContainer = () => {

  const dispatch = useDispatch();
  const [draftChallenge, setDraftChallenge] = useState(false);//TODO: [1
  const challenges = useSelector(state => state.dashboardChallenges.challenges);
  const sessionData = useSelector(state => state.session);
  const currentPlan = useSelector(state => state.dashboardPlan.currentPlan);
  const vendorId = getTeamVendorId(sessionData);

  useEffect(() => {
    dispatch(getCurrentChallenges({ vendorId }));
    dispatch(getCurrentPlan({vendorId}));
  }, []);

  const onRefresh = () => {
    dispatch(getCurrentChallenges({ vendorId }));
    setDraftChallenge(false);
  };

  return (<div className='vv-dashboard-challenges-container'>
    <h3>Wyzwania</h3>
    <span className='vv-dashboard-challenges-container__description'>To pierwsza na rynku progresywna karta lojalnościowa, która realnie wpływa na częstotliwość wizyt, a nie jest brana „przy okazji”.</span>
    <div className='vv-dashboard-challenges-container__challenges'>
      {challenges.map((challenge, i) => <Challenge vendorId={vendorId} key={i} challenge={challenge} currentPlan={currentPlan}/>)}
      {draftChallenge && <Challenge vendorId={vendorId} isNew={true} currentPlan={currentPlan} refresh={onRefresh}/> }
      <div className='vv-dashboard-challenges-container__footer' onClick={() => setDraftChallenge(true)}><IconPlus/><p>Dodaj kolejne wyzwanie</p></div>
    </div>
  </div>);
};
